export default __webpack_public_path__ + "static/media/376.0ef12d71.png";